const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const ChallengeAdd = () => import(/* webpackChunkName: "challenge" */ './view/add.vue');
const ChallengeEdit = () => import(/* webpackChunkName: "challenge" */ './view/edit.vue');
const ChallengeList = () => import(/* webpackChunkName: "challenge" */ './view/index.vue');
const ChallengeTranslate = () => import(/* webpackChunkName: "challenge" */ './view/translate.vue');

export const ROUTE_NAME_CHALLENGE = {
    INDEX: 'ChallengeList',
    ADD: 'ChallengeAdd',
    EDIT: 'ChallengeEdit',
    TRANSLATE: 'ChallengeTranslate'
};

export default [
    {
        path: '/app/:appId/challenge',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_CHALLENGE.INDEX,
                component: ChallengeList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_CHALLENGE.ADD,
                component: ChallengeAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_CHALLENGE.EDIT,
                component: ChallengeEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/translate',
                name: ROUTE_NAME_CHALLENGE.TRANSLATE,
                component: ChallengeTranslate,
                meta: { requiresAuth: true }
            }
        ]
    }
];
